import { useMutation, type UseMutationOptions } from '@tanstack/vue-query'
import useTenantApi from './tenantApi'
import type {
  authLoginResponse,
  loginPayload,
  loginResponse,
  otpPayload,
  otpResponse,
  confirmOtpResponse,
  getOtpPayload,
  getOtpRes,
  getOtpResponse,
  verifyLinePayload,
  validateLoginStatePayload,
  validateLoginStateResponse,
} from '@/interfaces/auth'
import type { AxiosError } from 'axios'

// const queryClient = useQueryClient()

const fetchLogin = async (payload: loginPayload): Promise<loginResponse> => {
  const { data } = await useTenantApi().post<authLoginResponse>('/auth/authLogin', payload)

  if (!data.success) {
    throw new Error(data.message)
  }

  return { ...data.item, key: data.key } as loginResponse
}

export const useLogin = (options?: UseMutationOptions<loginResponse, AxiosError, loginPayload>) => {
  return useMutation({
    mutationFn: (payload: loginPayload) => fetchLogin(payload),
    ...options,
  })
}

const fetchGetOtp = async (payload: getOtpPayload): Promise<getOtpRes> => {
  const { data } = await useTenantApi().post<getOtpResponse>('/OTP/getOtp', payload)

  if (!data.success) {
    throw new Error(data.message)
  }

  return data.item as getOtpRes
}

export const useGetOtp = (options?: UseMutationOptions<getOtpRes, AxiosError, getOtpPayload>) => {
  return useMutation({
    mutationFn: (payload: getOtpPayload) => fetchGetOtp(payload),
    ...options,
  })
}
const fetchConfirmOtp = async (payload: otpPayload): Promise<otpResponse> => {
  const { data } = await useTenantApi().post<confirmOtpResponse>('/OTP/confirmOTP', payload)

  if (!data.success) {
    throw new Error(data.message)
  }

  return data.item as otpResponse
}

export const useConfirmOtp = (
  options?: UseMutationOptions<otpResponse, AxiosError, otpPayload>,
) => {
  return useMutation({
    mutationFn: (payload: otpPayload) => fetchConfirmOtp(payload),
    ...options,
  })
}

const fetchUpdateVerifyLine = async (payload: verifyLinePayload) => {
  const { data } = await useTenantApi().post('/User/updateVerifyLine', payload)

  if (!data.success) {
    throw new Error(data.message)
  }

  return data.item
}

export const useUpdateVerifyLine = (
  options?: UseMutationOptions<unknown, AxiosError, verifyLinePayload>,
) => {
  return useMutation({
    mutationFn: (payload: verifyLinePayload) => fetchUpdateVerifyLine(payload),
    ...options,
  })
}

const fetchValidateLoginState = async (
  payload: validateLoginStatePayload,
): Promise<loginResponse> => {
  const { data } = await useTenantApi().post<validateLoginStateResponse>(
    '/Auth/validateAuthStatus',
    payload,
  )

  if (!data.success) {
    throw new Error(data.message)
  }

  return { ...data.item, key: data.key } as loginResponse
}

export const useValidateLoginState = (
  options?: UseMutationOptions<loginResponse, AxiosError, validateLoginStatePayload>,
) => {
  return useMutation({
    mutationFn: (payload: validateLoginStatePayload) => fetchValidateLoginState(payload),
    ...options,
  })
}
